export default {
  titleTemplate: '%s：アクセシビリティ サポーテッド（AS）情報',
  title: 'ホーム'
};
